import React from "react";
import { useSelector } from "react-redux";
import { translateComponent } from "../../../../../utils/services/translate";
import currencyLabel from "../../../../../utils/helper/currencyLabel";
import moment from "moment";
import "moment/locale/sv";
import "moment/locale/en-gb";
import "moment/locale/fi";
import "moment/locale/nb";
import "./styles.scss";

function BasketSummaryComponent() {
  const basket = useSelector((state) => state.Order.basket);
  const language = useSelector((state) => state.Layout.language);
  const projectData = useSelector((state) => state.Project.project);
  const translations = useSelector((state) => state.Layout.translations);

  const formatDateWithDay = (date, locale) => {
    const formattedDate = moment
      .utc(date, moment.ISO_8601)
      .locale(locale)
      .format("dddd, YYYY-MM-DD HH:mm");
    return formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1);
  };  
    if (basket.basketValid) {
      return (
        <div className="basket-wrapper">
          <div className="table-responsive">
            <table className="table basket-summary-table">
              <thead className="bg-light">
                <tr>
                  <th scope="col" className="product-column">
                    <p className="text-m p-0 m-0">
                      {translateComponent(
                        translations,
                        language,
                        "basketSummaryComponent",
                        "product"
                      )}
                    </p>
                  </th>
                  <th scope="col" className="text-center quantity-column">
                    <p className="text-m p-0 m-0">
                      {translateComponent(
                        translations,
                        language,
                        "basketSummaryComponent",
                        "count"
                      )}
                    </p>
                  </th>
                  <th scope="col" className="text-center price-column">
                    <p className="text-m p-0 m-0">
                      {translateComponent(
                        translations,
                        language,
                        "basketSummaryComponent",
                        "price"
                      )}
                    </p>
                  </th>
                </tr>
              </thead>
              <tbody>
                {basket.products.map((product, index) => {
                  const productTranslation = product.translations.find(
                    (t) => t.locale === language
                  );
                  return (
                    <tr key={index}>
                      <td className="product-info">
                        <div className="product-name  text-m mb-1">
                          {productTranslation.name}
                        </div>
                        <div className="product-description small">
                          {productTranslation.description}
                        </div>
                        {product.type === "reservedSeatTicket" && (
                          <div className="departure-time small text-muted">
                            {formatDateWithDay(
                              product.departure.departureTime,
                              language
                            )}
                          </div>
                        )}
                      </td>
                      <td className="text-center align-middle quantity-column">
                        <span className="text-m">{product.quantity}</span>
                      </td>
                      <td className="text-center align-middle price-column">
                        <span className="text-m">
                          {product.price} {currencyLabel(language, projectData.currency)}
                        </span>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      );
    }
    return null;
}

export default BasketSummaryComponent;